<template>
  <Wrapper
    ref="wrapper"
    type-list="members"
    :item-source="fetchClanMembers"
    has-search
    :dummy-props="{
      headerText: $t('_web_account-list_dummy_clan_members', ''),
      text: $t('_web_account-list_dummy_clan_members_subheader', ''),
    }"
  >
    <MembersListItem
      :key="user.login"
      slot-scope="{ user }"
      v-bind="{ user }"
      class="mb-4"
      @openChat="openChat(user)"
      @setAsOwner="setAsOwner(user)"
      @updateRole="updateRole(user, $event)"
      @removeFromClan="removeFromClan(user)"
    />
  </Wrapper>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { CLAN_ROLES } from '@/constants/accounts';
import popoverChat from '@/mixins/popoverChat';
import Wrapper from '../ListWrapper';
import MembersListItem from './MembersListItem';

export default {
  name: 'ClanMembersList',
  components: {
    Wrapper,
    MembersListItem,
  },
  mixins: [popoverChat],
  computed: {
    ...mapState('current', ['accountId']),
  },
  methods: {
    ...mapMutations(['updateAccountKey', 'updateCounterKey']),
    ...mapMutations('current', ['updateAccountModel']),
    ...mapActions([
      'getConversationInfo',
      'cancelUserFromMyClan',
      'updateRoleInClan',
      'fetchClanMembers',
      'errorNotify',
      'openModal',
      'closeModal',
    ]),
    ...mapActions('my', ['fetchMyAccount']),
    setAsOwner(user) {
      this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_clan_set-owner',
            'Do you want to make {login} an owner?',
            user
          ),
        },
        events: {
          cancel: this.closeModal,
          confirm: () => {
            this.updateRole(user, CLAN_ROLES.OWNER);
            this.updateAccountModel({ role: CLAN_ROLES.MEMBER });
            this.fetchMyAccount()
              .then(this.updateAccountKey)
              .finally(this.closeModal);
          },
        },
      });
    },
    updateRole(user, role) {
      return this.updateRoleInClan({
        clanID: this.accountId,
        login: user.login,
        role: {
          role,
        },
      })
        .then(() => {
          this.$set(user, 'role', role);
          return user;
        })
        .catch(this.errorNotify);
    },
    removeFromClan(user) {
      this.cancelUserFromMyClan({
        clanID: this.accountId,
        login: user.login,
      })
        .then(() => {
          this.$refs.wrapper.removeUser(user);
          this.updateCounterKey();

          return user;
        })
        .catch(this.errorNotify);
    },
    openChat(user) {
      if (innerWidth < 800) {
        this.getConversationInfo({ conversationId: user.login })
          .then(({ id }) => {
            this.$router.push({
              name: 'conversations',
              params: {
                id: id,
              },
            });
          })
          .catch(this.errorNotify);
      } else {
        this.openPopoverChat(user.login).then(() => this.$router.back());
      }
    },
  },
};
</script>
